import { computed, ref, onMounted } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-66f5e2f2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "table-content"
};
const _hoisted_2 = {
  key: 0,
  class: "handle-content"
};
import { OK, reportEvent } from '@/common';
import { message, Modal } from 'ant-design-vue';
import BlackModal from '@/views/orderManage/blackList/components/BlackModal.vue';
import { deleteBlackSetting, queryBlackList } from '@/api/blackApi';
import { useStore } from "@/store";
export default /*#__PURE__*/_defineComponent({
  __name: 'BlackTableBlock',
  setup(__props, {
    expose
  }) {
    const userInfo = computed(() => useStore().userInfo && JSON.parse(useStore().userInfo));
    const columns = [{
      title: '设备号',
      dataIndex: 'deviceId',
      key: 'deviceId',
      width: 350
    }, {
      title: '创建人',
      dataIndex: 'createUser',
      key: 'createUser',
      width: 350
    }, {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
      width: 350
    }, {
      title: '操作内容',
      dataIndex: 'handle',
      key: 'handle',
      align: 'right'
    }];
    const dataSource = ref([]);
    const pageIndex = ref(1);
    const pageSize = ref(20);
    const pageTotal = ref(0);
    const searchObj = ref({});
    const tableRef = ref();
    const detailVisible = ref(false);
    const editItem = ref([]);
    const getData = async () => {
      let startTime = new Date().getTime();
      let params = {
        pageNum: pageIndex.value,
        pageSize: pageSize.value
      };
      Object.keys(searchObj.value).forEach(item => {
        if (searchObj.value[item] || searchObj.value[item] === 0) {
          params = {
            ...params,
            [item]: searchObj.value[item]
          };
        }
      });
      try {
        const {
          data,
          code,
          count
        } = await queryBlackList(params);
        if (code === OK) {
          pageTotal.value = count;
          dataSource.value = data;
          reportEvent({
            eventName: '_search',
            properties: {
              ui_name: '黑名单查询',
              app_name: '',
              return_duration: (new Date().getTime() - startTime) / 1000,
              query_status: 'succeed'
            }
          });
        } else {
          reportEvent({
            eventName: '_search',
            properties: {
              ui_name: '黑名单查询',
              app_name: '',
              return_duration: (new Date().getTime() - startTime) / 1000,
              query_status: 'failed'
            }
          });
        }
      } catch (e) {
        reportEvent({
          eventName: '_search',
          properties: {
            ui_name: '黑名单查询',
            app_name: '',
            return_duration: (new Date().getTime() - startTime) / 1000,
            query_status: 'failed'
          }
        });
      }
    };
    const searchData = async obj => {
      pageIndex.value = 1;
      searchObj.value = obj;
      await getData();
    };
    const changePage = async (page, pageS) => {
      pageIndex.value = page;
      pageSize.value = pageS;
      await getData();
    };
    const openDetail = async item => {
      editItem.value = item;
      detailVisible.value = true;
    };
    const addNewBlack = () => {
      detailVisible.value = true;
    };
    const deleteBlack = item => {
      Modal.confirm({
        title: '提示',
        content: '是否删除该数据？',
        centered: true,
        onOk: async () => {
          try {
            const {
              msg,
              code
            } = await deleteBlackSetting({
              id: item.id
            });
            if (code === OK) {
              message.success(msg);
              pageIndex.value = 1;
              await getData();
              reportEvent({
                eventName: 'element_use',
                properties: {
                  'ui_name': '黑名单查询',
                  'element_name': '删除配置'
                }
              });
            }
          } catch (e) {}
        }
      });
    };
    onMounted(async () => {
      await getData();
    });
    expose({
      searchData
    });
    return (_ctx, _cache) => {
      var _unref2;
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createBlock(_component_a_button, {
        type: "primary",
        onClick: addNewBlack,
        class: "add-btn"
      }, {
        icon: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": "add",
          "class-name": "add-icon"
        })]),
        default: _withCtx(() => [_createTextVNode(" 新增配置 ")]),
        _: 1
      })), [[_directive_permission, {
        permissionValue: 'blackList',
        permissionArr: (_unref2 = _unref(userInfo)) === null || _unref2 === void 0 ? void 0 : _unref2.permissions
      }]]), _createVNode(_component_a_table, {
        bordered: "",
        columns: columns,
        "data-source": dataSource.value,
        "row-key": "id",
        pagination: false,
        ref_key: "tableRef",
        ref: tableRef
      }, {
        bodyCell: _withCtx(({
          column,
          record
        }) => {
          var _unref3;
          return [column.dataIndex === 'handle' ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_a_button, {
            type: "link",
            onClick: $event => openDetail(record)
          }, {
            default: _withCtx(() => [_createTextVNode("编辑")]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_a_button, {
            type: "link",
            danger: "",
            onClick: $event => deleteBlack(record)
          }, {
            default: _withCtx(() => [_createTextVNode("删除")]),
            _: 2
          }, 1032, ["onClick"])])), [[_directive_permission, {
            permissionValue: 'blackList',
            permissionArr: (_unref3 = _unref(userInfo)) === null || _unref3 === void 0 ? void 0 : _unref3.permissions
          }]]) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["data-source"]), _createVNode(_component_a_pagination, {
        onChange: changePage,
        current: pageIndex.value,
        "onUpdate:current": _cache[0] || (_cache[0] = $event => pageIndex.value = $event),
        pageSize: pageSize.value,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => pageSize.value = $event),
        total: pageTotal.value,
        "show-size-changer": "",
        "show-total": total => `共 ${total} 条`
      }, null, 8, ["current", "pageSize", "total", "show-total"]), _createVNode(BlackModal, {
        "modal-visible": detailVisible.value,
        "onUpdate:modal-visible": _cache[2] || (_cache[2] = $event => detailVisible.value = $event),
        "edit-item": editItem.value,
        "onUpdate:edit-item": _cache[3] || (_cache[3] = $event => editItem.value = $event),
        onRefreshList: getData
      }, null, 8, ["modal-visible", "edit-item"])]);
    };
  }
});